export default {
    horizontal: 'horizontal',
    vertical:   'vertical',
};
